import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Helpers from "../../utils/helpers";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "primereact/button";

interface selectedInvoiceDataProps {
  selectedInvoice: any;
  orderinfo: any;
}

interface Invoice {
  invoiceNo: number; 
}

const InviceItems: React.FC<selectedInvoiceDataProps> = ({ selectedInvoice, orderinfo }) => {
  const invoiceRef = useRef(null);
  const [firstInvoice, setFirstInvoice] = useState<any>();

  useEffect(() => {
    if (orderinfo.orderInvoice.length > 0) {
      const lowestInvoice = orderinfo.orderInvoice.reduce((minInvoice: Invoice, currentInvoice: Invoice) => {
        return currentInvoice.invoiceNo < minInvoice.invoiceNo ? currentInvoice : minInvoice;
      });
      setFirstInvoice(lowestInvoice.invoiceNo);
    }
  }, [orderinfo.orderInvoice]);

  const handleInvoicePrint = useReactToPrint({
    content: () => invoiceRef.current,
    documentTitle: 'Invoce Details',
    pageStyle: `@page { margin-top: 5mm; margin-left: 5mm; margin-right: 3mm; margin-bottom: 1mm; }`
  });

  const priceBodyTemplate = (invoice: any) => {
    return Helpers.formatAmountInINR(invoice.unitPrice);
  };

  const quantityBodyTemplate = (invoice: any) => {
    return invoice.invoicedQuantity + " (" + invoice.measurementTypeCode + ")";
  };

  const amountBodyTemplate = (invoice: any) => {
    return Helpers.formatAmountInINR(invoice.invoicedQuantity * invoice.unitPrice);
  };

  const taxBodyTemplate = (invoice: any) => {
    return Helpers.formatAmountInINR(invoice.invoicedQuantity * invoice.unitPrice * invoice.gst / 100);
  };

  const totalAmountBodyTemplate = (invoice: any) => {
    return Helpers.formatAmountInINR(Math.round(invoice.totalAmount));
  };

  const headerTemplate = (
    <>
    <div className="grid">
      <div className="col-6">
        <div className="grid mb-3">
          <img src={process.env.PUBLIC_URL + "/assests/images/DesiriLogo.png"} width={100} />
        </div>
        {
            orderinfo?.orderInvoice?.[0]?.pos &&  // Ensure pos exists in the first orderInvoice item
            <div>
              <div className="grid">
                <div className="col">From:<br /> <span className="text-primary">Desiri Naturals Pvt Ltd</span></div>
              </div>
              <div className="grid">
                {orderinfo.orderInvoice[0].pos.address1 &&
                  <div className="col">
                    <span className="text-primary">
                      {orderinfo.orderInvoice[0].pos.address1}
                      {orderinfo.orderInvoice[0].pos.address2 && `, ${orderinfo.orderInvoice[0].pos.address2}`}
                      {orderinfo.orderInvoice[0].pos.landmark && `, ${orderinfo.orderInvoice[0].pos.landmark}`}
                      {orderinfo.orderInvoice[0].pos.cityName && `, ${orderinfo.orderInvoice[0].pos.cityName}`}
                      {orderinfo.orderInvoice[0].pos.stateName && `, ${orderinfo.orderInvoice[0].pos.stateName}`}
                    </span><br />
                    Pin: <span className="text-primary">{orderinfo.orderInvoice[0].pos.zipcode}</span>
                  </div>
                }
              </div>
              <div className="grid">
                {
                  orderinfo.orderInvoice[0].pos.address1 &&
                  <div className="col">
                    GST #: <span className="text-primary">29AAGCD5864J1Z4</span>
                  </div>
                }
              </div>
            </div>
        }        
        <div className="grid">
          <div className="col">To:<br/> <span className="text-primary">{orderinfo.userName}</span></div>
        </div>     
        <div className="grid">
          <div className="col">Delivery Address:<br/>  
            <span className="text-primary"> {orderinfo.address1},{orderinfo.address2}, {orderinfo.areaName}, {orderinfo.subDistrictName}, {orderinfo.districtName}, {orderinfo.stateName}, {orderinfo.countryName} </span><br/>
            Pin:  <span className="text-primary"> {orderinfo.zipcode}</span>
          </div>
        </div>
        <div className="grid">
          <div className="col">Mobile #:  <span className="text-primary">{orderinfo.primaryContactNbr}</span></div>
        </div>
        {orderinfo.gsT_Number !== null && <div className="grid">
          <div className="col">GST #:  <span className="text-primary">{orderinfo.gsT_Number}</span></div>
        </div>}
      </div>
      <div className="col-1">        
      </div>
      <div className="col-5">
        <div className="grid mt-7">
          <div className="col">Order #: <span className="text-primary"> {orderinfo?.orderID}</span></div>
        </div>
        <div className="grid">
          <div className="col">Order Date: <span className="text-primary"> {new Date( orderinfo?.createdDate).toLocaleDateString("en-gb", 
            {
              day: "2-digit",
              month: "short",
              year: "numeric"
            })}</span>             
          </div>
        </div>
        <div className="grid">
          <div className="col">Invoice #: <span className="text-primary"> {selectedInvoice?.invoiceNo}</span></div>
        </div>
        <div className="grid">
          <div className="col">Invoice Date: <span className="text-primary"> {new Date(selectedInvoice?.invoicedDate).toLocaleDateString("en-gb", 
              {
                day: "2-digit",
                month: "short",
                year: "numeric"
              })}
            </span>
            </div>
          </div>
          <div className="grid">
            <div className="col">Invoice Amount: <span className="text-primary">{Helpers.formatAmountInINR(selectedInvoice.grossAmount)}</span></div>
          </div>
          <div className="grid">
            <div className="col">Payment Mode: <span className="text-primary"> {Helpers.formatPaymentMode(selectedInvoice?.paymentModeName)}</span></div>
          </div>
        </div>
      </div>
    </>
  );
  const footerTemplate = (
    <>
      <div className="grid">
        <div className="col-7">
        </div>
        <div className="col-5">
          <div className="grid">
            <div className="col">Taxable Amount:
              <div className="mr-2" style={{ float: "right" }}>{Helpers.formatAmountInINR(selectedInvoice.taxableAmount)}</div>
            </div>
          </div>
          <div className="grid">
            <div className="col">Tax Amount:
              <div className="mr-2" style={{ float: "right" }}>{Helpers.formatAmountInINR(selectedInvoice.taxAmount)}</div>
            </div>
          </div>
          {/* <div className="grid">
            <div className="col">Handling Charges:
              <div className="mr-2" style={{ float: "right" }}>
                {selectedInvoice.invoiceNo === firstInvoice ?
                  Helpers.formatAmountInINR(orderinfo.handlingCharges) :
                  '0'
                }
              </div>
            </div>
          </div> */}
          <div className="grid">
            <div className="col">Courier Charges:
              <div className="mr-2" style={{ float: "right" }}>
                
                {selectedInvoice.invoiceNo === firstInvoice ?
                  Helpers.formatAmountInINR(orderinfo.courierCharges) :
                  '0'
                }
              </div>
            </div>
          </div>
          {/* <div className="grid">
            <div className="col">Packing Charges:
              <div className="mr-2" style={{ float: "right" }}>
                {selectedInvoice.invoiceNo === firstInvoice ?
                  Helpers.formatAmountInINR(orderinfo.packingCharges) :
                  '0'
                }
              </div>
            </div>
          </div> */}
          {
            selectedInvoice.paymentGatewayCharges > 0 ?
            <div className="grid">
              <div className="col">Payment Gateway Charges:
                <div className="mr-2" style={{ float: "right" }}>
                  {
                    Helpers.formatAmountInINR(selectedInvoice.paymentGatewayCharges)
                  }
                </div>
              </div>
            </div> : ""
          }
          {
            selectedInvoice.discountAmount > 0 ?
            <div className="grid">
              <div className="col">Discount Amount:
              <div className="mr-2" style={{ float: "right" }}>
                {
                  Helpers.formatAmountInINR(selectedInvoice.discountAmount)
                }
              </div>
            </div>
          </div>
          :""
          }
          <div className="grid">
            <div className="col">Total Amount:
              <div className="mr-2 text-primary" style={{ float: "right" }}>{Helpers.formatAmountInINR(selectedInvoice.grossAmount)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return (
    <>
      <div className="grid">

        <div className="col">Invoice Details
          <Button icon="pi pi-print" style={{ float: "right" }}
            onClick={handleInvoicePrint} rounded text severity="info" aria-label="User" />
        </div>
      </div>
      <div ref={invoiceRef} style={{ overflowX: 'hidden' }}>
        <DataTable
          value={selectedInvoice.orderInvoiceDetail} className="no-flex"
          header={headerTemplate} footer={footerTemplate} size="small"
        >
          <Column field="productName" header="Name" />
          <Column field="unitPrice" header="Price" body={priceBodyTemplate} />
          <Column field="invoicedQuantity" header="Quantity" body={quantityBodyTemplate} />
          <Column header="Amount" body={amountBodyTemplate} />
          <Column header="Tax" body={taxBodyTemplate} />
          <Column field="totalAmount" header="Total" body={totalAmountBodyTemplate} />
        </DataTable>
      </div>
    </>
  );
};

export default InviceItems;
